export default __webpack_public_path__ + "45fff29c786b627d4ee2b1d36c013ce7.svg";